import React from "react";
import "./shopify-platform-indicator.scss";
import IconShopify from "../../../../../../components/icons/icon-shopify/icon-shopify";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import Icon from "../../../../../../components/icons/icon/icon";

export const ShopifyPlatformIndicator: React.FC = () => (
    <div className="shopify-platform-indicator">
        <Icon Component={IconShopify} />
        <FontBody2>Shopify</FontBody2>
    </div>
);
